import { ConfirmDialog, toHash } from '@h2oai/ui-kit';
import { useCallback, useEffect, useMemo } from 'react';
import * as ReactDOMServer from 'react-dom/server';
import { Redirect, useLocation } from 'react-router-dom';

import { Eula, EulaWrapper } from '../components/Eula';
import { LocalStorageKeys } from '../constants/localStorage';
import AuthPage from '../pages/AuthPage/AuthPage';
import { useLocalStorage } from '../utils/hooks';
import { migrateLocalStorage } from '../utils/localStorageMigration';

export const EULA_LOCALSTORAGE_KEY = LocalStorageKeys.EULA_ACCEPTED;

// Migrate old localStorage format before component mounts
// This ensures migration happens before useLocalStorage reads the value
migrateLocalStorage();

function App() {
  const eula = useMemo(() => toHash(ReactDOMServer.renderToString(Eula())), []);

  const [storedEula, setStoredEula] = useLocalStorage<string>(EULA_LOCALSTORAGE_KEY);
  const existingEula = Boolean(storedEula);
  const acceptedEula = storedEula === eula;

  const acceptEula = useCallback(() => {
    setStoredEula(eula);
  }, [eula, setStoredEula]);

  useEffect(() => {
    // automatically accept EULA if we are using mocked data, and not using a local identity provider
    if (process.env.REACT_APP_USE_MOCK_SERVER && !process.env.REACT_APP_USE_IDP) {
      acceptEula();
    }
  }, [acceptEula]);

  const location = useLocation();

  return location.pathname === `/logout` ? (
    <Redirect to="/" />
  ) : acceptedEula ? (
    <AuthPage />
  ) : (
    <ConfirmDialog
      data-test="login-dialog"
      title="EULA"
      hidden={false}
      content={EulaWrapper(existingEula)}
      confirmationButtonText="I agree"
      onConfirm={acceptEula}
      maxWidth={1000}
      minWidth="50%"
      suppressDismissalButton={true}
      styles={{ root: { 'button[aria-label="Close"]': { visibility: 'hidden' } } }}
    />
  );
}

export default App;
